// import React,{Component} from "react";

// // reactstrap components
// import {
//   Col,
//   Label
// } from "reactstrap";
// import { Radio } from '@mui/material';
// import "components/custom.css";

// class SingleAnswer extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       question:"",
//       secondCount:1200,
//       questionId:"",
//       reset:false,
//       selectedValue:'',
//       is_answer:false,
//       correctFlag:true,
//       resultObj:{}
//     };
//   }

//   componentDidMount() {
    
//   	var intervalId = setInterval(this.timer, 1000);
//     this.setState({intervalId: intervalId});
//   }

//   handleChange = (event) => {
//     this.props.showResult();
//     let correct = this.props.data.option.filter(function (item) {
//   return item.correct == 1;
// })[0].id;
//     this.setState({selectedValue: event.target.value,resultObj:{'answer':event.target.value,'correct':correct} });
//     this.props.submit({'answer':event.target.value,'correct':correct},true);
//   };

//   updateCorrect = () =>{
//     let correct = this.props.data.option.filter(function (item) {
//   return item.correct == 1;
// })[0].id;
//     this.props.submit({'answer':"",'correct':correct});
//     this.setState({correctFlag:false,resultObj:{'answer':"",'correct':correct}})
//   } 

//   static getDerivedStateFromProps(props, state) {
//   	if (props.data) {
//   		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//   			clearInterval(state.intervalId);
//   			clearInterval(state.recordId);
//   			return {correctFlag:true,secondCount:1200,questionId: props.data.id,reset:true};
//   		}else{
//   			if (!state.questionId) {
//   				return {correctFlag:true,questionId: props.data.id};
//   			}
//   		}
  		
//   		}    
//   }

// 	timer = () => {
// 		if (this.state.secondCount === 1) {
// 			clearInterval(this.state.intervalId);
// 		}
// 		this.setState({ secondCount: this.state.secondCount -1 });
// 	}

// 	componentWillUnmount = () => {
// 		clearInterval(this.state.intervalId);
// 	}

//   showAnswer = () => {
//     if (this.props.answer != this.state.is_answer) {
//       this.setState({is_answer:true});  
//     }
//   }

//   stopTest = () =>{
//     this.props.nextQuestion(this.state.resultObj);
//   }
  
//   render() {
//   	let question ="";
//     if (this.props.restart) {
//       this.props.restartQue();
//     }

//     if (this.props.stopRecording) {
//       this.stopTest();      
//     }
//   	if (this.props.data) {
//   		question = this.props.data.question;
//       if (this.state.correctFlag) {
//         this.updateCorrect();  
//       }
//   	}

//     if (this.props.answer) {
//       this.showAnswer();
//     }

//   	if (this.state.reset) {
//   		var intervalId = setInterval(this.timer, 1000);
// 		  this.setState({intervalId: intervalId,reset:false,is_answer:false});
//   	}
//     return (
//       <>
//       <Col xs={12} className="mb-4">
//       	<h4 className="infoText"></h4>
//       </Col>
//       <div className="container-fluid">
//         <div className="row">
//           <Col xs={6}><h5>{question}</h5></Col>
//           <Col xs={6}>
//             <h3 className="question">{this.props.data && this.props.data.question_mcq}</h3>
//             <div className="answers">
//               {this.props.data && this.props.resultMode && this.props.data.option.map(function(item){
//                   return <React.Fragment>
//                         <Label className={ this.state.is_answer && item.correct === 1 && 'correct-line' }>
//                           <Radio
//                               checked={this.state.selectedValue == item.id}
//                               value={item.id}
//                               color="default"
//                               onChange={this.handleChange}
//                               inputProps={{ 'aria-label': 'secondary checkbox' }}
//                               name="answer"
//                             />{' '}
//                           {item.options}
//                         </Label>
//                       </React.Fragment>;
//               },this) }
//               {this.props.data && !this.props.resultMode && this.props.data.option.map(function(item){
//                   return <React.Fragment>
//                           <Label className={ this.props.answer && (item.correct === 1?(this.state.selectedValue == item.id?'correct-line':'blue-line'):(this.state.selectedValue == item.id)?'red-line':'') }>
//                             <Radio
//                               checked={this.state.selectedValue == item.id}
//                               value={item.id}
//                               color="default"
//                               onChange={this.handleChange}
//                               inputProps={{ 'aria-label': 'secondary checkbox' }}
//                               name="answer"
//                             />{' '}
//                             {item.options}
//                           </Label>
//                         </React.Fragment>;
//                 },this) }
//             </div>
//           </Col>
//         </div>
//       </div>
//       </>
//     );
//   }
// }

// export default SingleAnswer;

import React, { useState, useEffect, useRef } from "react";
import {Col , Form} from "react-bootstrap";
import { Radio } from '@mui/material';
import "components/custom.css";

const SingleAnswer = (props) => {
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(1200);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [is_answer, setIs_answer] = useState(false);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  
  const intervalIdRef = useRef(null);
  const recordIdRef = useRef(null);

  const timer = () => {
    setSecondCount(prevCount => {
      if (prevCount === 1) {
        clearInterval(intervalIdRef.current);
      }
      return prevCount - 1;
    });
  };

  useEffect(() => {
    intervalIdRef.current = setInterval(timer, 1000);
    
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);
        setCorrectFlag(true);
        setSecondCount(1200);
        setQuestionId(props.data.id);
        setReset(true);
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart, questionId]);

  useEffect(() => {
    if (reset) {
      intervalIdRef.current = setInterval(timer, 1000);
      setReset(false);
      setIs_answer(false);
    }
  }, [reset]);

  const handleChange = (event) => {
    props.showResult();
    let correct = props.data.option.filter(function (item) {
      return item.correct == 1;
    })[0].id;
    console.log(correct);
    setSelectedValue(event.target.value);
    setResultObj({'answer': event.target.value, 'correct': correct});
    props.submit({'answer': event.target.value, 'correct': correct}, true);
  };

  const updateCorrect = () => {
    let correct = props.data.option.filter(function (item) {
      return item.correct == 1;
    })[0].id;
    props.submit({'answer': "", 'correct': correct});
    setCorrectFlag(false);
    setResultObj({'answer': "", 'correct': correct});
  };

  const showAnswer = () => {
    if (props.answer != is_answer) {
      setIs_answer(true);
    }
  };

  const stopTest = () => {
    props.nextQuestion(resultObj);
  };

  let questionText = "";
  if (props.restart) {
    props.restartQue();
  }

  useEffect(() => {
    if (props.stopRecording) {
      console.log('SingleAnswer: stopRecording detected, calling stopTest');
      stopTest();
    }
  }, [props.stopRecording]);

  if (props.data) {
    questionText = props.data.question;
    if (correctFlag) {
      updateCorrect();
    }
  }

  if (props.answer) {
    showAnswer();
  }

  return (
    <>
      {!props.resultMode &&
        <Col xs={12} className="mb-4">
          <h4 className="infoText"></h4>
        </Col>
      }
      <div className="container-fluid">
        <div className="row">
          <Col xs={12} lg={props.resultMode ? 12 : 6}><h5 className={props.resultMode ? "reading-text text-start":""}>{questionText}</h5></Col>
          <Col xs={12} lg={6}>
            <h3 className="question mock-resource-text">{props.data && !props.resultMode && props.data.question_mcq}</h3>
            <div className="answers">
              {props.data && false && props.data.option.map(function(item){
                return <React.Fragment key={item.id}>
                      <Form.Label className={is_answer && item.correct === 1 && 'correct-line'}>
                        <span className={`${selectedValue == item.id ? "selected-option": ""}`}>
                          <Radio
                            checked={selectedValue == item.id}
                            value={item.id}
                            color="default"
                            className="option-checkbox"
                            // onChange={handleChange}
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                            name="answer"
                          />{' '}
                          {item.options}
                        </span>
                      </Form.Label>
                    </React.Fragment>;
              })}
              {props.data && !props.resultMode && props.data.option.map(function(item){
                return <React.Fragment key={item.id}>
                        <Form.Label className={`${props.answer && (item.correct === 1 ? (selectedValue == item.id ? 'correct-line' : 'blue-line') : (selectedValue == item.id) ? 'red-line' : '')}`}>
                        <span className={`${selectedValue == item.id ? "selected-option": ""}`}>
                          <Radio
                            checked={selectedValue == item.id}
                            value={item.id}
                            color="default"
                            className="option-checkbox"
                            sx={{
                              color: "var(--checkbox-default) !important",
                              "&.Mui-checked": {
                                color: "var(--checkbox-checked) !important",
                              },
                            }}
                            onChange={handleChange}
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                            name="answer"
                          />{' '}
                          {item.options}
                        </span>
                        </Form.Label>
                      </React.Fragment>;
              })}
            </div>
          </Col>
        </div>
      </div>
    </>
  );
};

export default SingleAnswer;